// extracted by mini-css-extract-plugin
export default {"playerWrapper":"index_playerWrapper__jt8cX","steps":"index_steps__7QD8s","step":"index_step__NN1Gg","activeStep":"index_activeStep__IflWd"};